import { useEffect } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import {
  useFetchJobTasks,
  useFetchTask,
  useFetchParcel,
} from "@labeling-tools/api/lebron/react-query-hooks";
import { LoadingOverlay } from "@mantine/core";
import { AdminToolbar } from "../components/AdminToolbar";
import { CoverageTask } from "./CoverageTask";


export const AdminCoverageTask = () => {
  const navigate = useNavigate();
  const { jobId } = useParams();
  const [searchParams] = useSearchParams();
  const taskId = searchParams.get("taskId");

  const { data: jobTasks, isLoading: jobTasksLoading } = useFetchJobTasks(
    jobId || "",
  );
  const { data: task, isLoading: taskLoading } = useFetchTask(
    jobId || "",
    taskId || jobTasks?.tasks[0]?.id,
  );

  const parcelId = task?.data?.parcel_id as string | undefined;
  const { data: parcel, isLoading: parcelLoading } = useFetchParcel(parcelId);

  // Default to first task if no taskId in URL
  useEffect(() => {
    if (task && !taskId && jobTasks?.tasks[0]?.id) {
      navigate(
        `/jobs/${jobId}/admin-coverage?taskId=${jobTasks.tasks[0].id}`,
        { replace: true },
      );
    }
  }, [task, taskId, jobId, jobTasks, navigate]);

  if (jobTasksLoading || taskLoading || parcelLoading) {
    return <LoadingOverlay visible={true} />;
  }

  return (
    <div>
      {/* Admin toolbar */}
      {jobTasks && task && (
        <AdminToolbar jobTasks={jobTasks} activeTask={task} />
      )}

      {/* Coverage task in admin (read-only) mode — key on task.id to reset all
           internal state (image mutation, zoom, selections) when navigating */}
      {task && parcel && (
        <CoverageTask key={task.id} mode="admin" adminTask={task} adminParcel={parcel} adminResult={task.result} />
      )}
    </div>
  );
};
